/**
 * Labstep
 *
 * @module components/Entity/ActionMenu
 * @desc Core action menu
 */

import { ActionComponentModalContainer as ActionComponent } from 'labstep-web/core/Action/Component';
import { Dropdown } from 'labstep-web/core/Dropdown';
import { DropdownPortal } from 'labstep-web/core/Dropdown/Portal';
import type { IconProps } from 'labstep-web/core/Icon/types';
import React from 'react';
import styles from './styles.module.scss';
import type { ActionMenuProps } from './types';

export const ActionMenu: React.FC<ActionMenuProps> = ({
  children,
  type,
  color,
  orientation,
  upward,
  size,
  dataCy,
  usePortal,
  ...rest
}) => {
  // temp fix
  if (!React.Children.toArray(children).length) {
    return null;
  }

  const props: Record<string, unknown> = {
    pointing: 'top right',
    icon: null,
    ...rest,
  };

  const iconName = `ellipsis ${orientation}` as IconProps['name'];

  switch (type) {
    default: {
      props.upward = upward;
      props.trigger = (
        <ActionComponent
          dataCy="trigger"
          type="icon"
          icon={iconName}
          elementProps={{ color, size }}
        />
      );
      break;
    }
  }

  if (usePortal) {
    return (
      <DropdownPortal
        {...props}
        data-cy={dataCy}
        xOffset={25}
        yOffset={-10}
      >
        {children}
        <Dropdown.Item className={styles.empty} disabled>
          No Actions
        </Dropdown.Item>
      </DropdownPortal>
    );
  }

  return (
    <Dropdown {...props} data-cy={dataCy}>
      {children}
      <Dropdown.Item className={styles.empty} disabled>
        No Actions
      </Dropdown.Item>
    </Dropdown>
  );
};

ActionMenu.defaultProps = {
  orientation: 'vertical',
};
